import React from 'react'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withState, lifecycle } from 'recompose'
import { PaymentMethodIntake } from '@drifthq/billing-components'

import { getOrgId, getCreateOrgFailed } from 'modules/org/selectors'
import { createOrg, updateOrgProperties } from 'modules/org/actions'

import { updatePassword } from 'modules/user/actions'
import { getEmail, getPassword, getAccessToken} from 'modules/user/selectors'

import { activateDeal } from 'modules/billing/actions'
import {
  getDeal,
  getActivateDealSucceeded,
  getActivateDealFailed,
  isBillingDealUpgrade,
  activateDealErrorMessage,
  getCustomerSegment } from 'modules/billing/selectors'

import { page, track } from 'utils/trackingUtils'

import { NewOrgAssignedProperties, NewOrgAssignedConfiguration } from 'constants/dealConstants'
import './style.css'
import { OnboardingHeader } from 'components/OnboardingHeader'


const BillingInfoStep = ({
  deal,
  onPaymentIntakeSubmitted,
  onPaymentIntakeCompleted,
  onPaymentIntakeCancelled,
  onPaymentStepChanged,
  isProcessingActivation,
  activateAccountFailed,
  showErrorNotification,
  activateAccountErrorMessage,
  isUpgrade
}) => {
  const header = title => <OnboardingHeader
    className="deal-billing-info-header"
    isPostdated={deal.postdated}
    title={title}
  />

  return (
    <div className="deal-billing-info-step">
      <PaymentMethodIntake
        completeButtonText= {isUpgrade ? 'Upgrade my account': 'Create my account'}
        onIntakeSubmitted={onPaymentIntakeSubmitted}
        onIntakeCompleted={onPaymentIntakeCompleted}
        onCancelIntake={onPaymentIntakeCancelled}
        isCompleteButtonProcessing={isProcessingActivation}
        showTerms={false}
        includeTitles={false}
        showErrorNotification={showErrorNotification}
        onStepChanged={onPaymentStepChanged}
        hideCancelLink={true}
        creditStepHeader={header('Add your payment info')}
        billingStepHeader={header('Add your billing address')}
        creditStepButtonText='Next'
      />
      { activateAccountFailed &&
        <div className="deal-billing-info-create-failed">
          {activateAccountErrorMessage}
        </div>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    email: getEmail(state),
    password: getPassword(state),
    orgId: getOrgId(state),
    deal: getDeal(state),
    isUpgrade: isBillingDealUpgrade(state),
    customerSegment: getCustomerSegment(state),
    accessToken: getAccessToken(state),
    activateDealSucceeded: getActivateDealSucceeded(state),
    activateDealFailed: getActivateDealFailed(state),
    createOrgFailed: getCreateOrgFailed(state),
    activateDealFailedErrorMessage: activateDealErrorMessage(state),
    dealSegment: getCustomerSegment(state)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
    pop: goBack,
    createOrg,
    updatePassword,
    updateOrgProperties,
    activateDeal,
  }, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('activateAccountFailed', 'setActivateAccountFailed', false),
  withState('activateAccountErrorMessage', 'setActivateAccountErrorMessage'),
  withState('recurlyTokenId', 'setRecurlyTokenId'),
  withState('isProcessingActivation', 'setIsProcessingActivation'),
  withHandlers({
    showErrorNotification: props => (error) => {
      props.setActivateAccountFailed(true)
      props.setIsProcessingActivation(false)
      props.setActivateAccountErrorMessage(error)
    },
    onPaymentStepChanged: props => (stepNumber) => {
      stepNumber === 0 ?
        track('Deal flow - Credit Card intake viewed') :
        track('Deal flow - Billing Info intake viewed')
    },
    onPaymentIntakeCancelled: props => () => {
      props.actions.pop()
    },
    onPaymentIntakeSubmitted: props => ({ recurlyTokenId }) => {
      if (recurlyTokenId) {
        props.setIsProcessingActivation(true)
        props.setRecurlyTokenId(recurlyTokenId)
      }
    },
    onPaymentIntakeCompleted: props => () => {
      if (props.isUpgrade) {
        props.actions.activateDeal({ dealId: props.deal.id, billingToken: props.recurlyTokenId, accessToken: props.accessToken })
      } else {
        props.actions.createOrg({ email: props.email, password: props.password, configurationOptions: NewOrgAssignedConfiguration })
      }
    },
    onNewOrgCreated: props => () => {
      props.actions.activateDeal({ dealId: props.deal.id, billingToken: props.recurlyTokenId, accessToken: props.accessToken })
    },
    onCreateOrgFailed: props => () => {
      props.setActivateAccountFailed(true)
      props.setActivateAccountErrorMessage('We encountered an error trying to create your Drift account - please try again')
      props.setIsProcessingActivation(false)
    },
    onActivateDealFailed: props => () => {
      props.setActivateAccountFailed(true)
      props.setIsProcessingActivation(false)
      props.setActivateAccountErrorMessage(props.activateDealFailedErrorMessage)
    },
    onActivateDealSuccess: props => () => {
      props.setIsProcessingActivation(false)
      if (props.isUpgrade) {
        props.actions.push('/deal-upgraded')
      }
      else {
        props.actions.updateOrgProperties({ properties: NewOrgAssignedProperties, redirect: false })
        props.actions.push('/onboarding')
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      page('Paid Deal Flow - Billing Info Step')
    },
    componentDidUpdate(prevProps) {
      if((prevProps.orgId !== this.props.orgId) && !!this.props.orgId) {
        this.props.onNewOrgCreated(this.props.orgId)
      }

      if((prevProps.createOrgFailed !== !!this.props.createOrgFailed) && this.props.createOrgFailed) {
        this.props.onCreateOrgFailed()
      }

      if((prevProps.activateDealSucceeded !== !!this.props.activateDealSucceeded) && this.props.activateDealSucceeded) {
        this.props.onActivateDealSuccess()
      }

      if((prevProps.activateDealFailed !== !!this.props.activateDealFailed) && this.props.activateDealFailed) {
        this.props.onActivateDealFailed()
      }
    }
  })
)(BillingInfoStep)



// WEBPACK FOOTER //
// ./src/layouts/Deal/BillingInfoStep/index.js